import axios from "axios";
import { refactorEventsGroupedByDateV1 } from "@/services/eventsOddsHandlerV3";

const state = {
    events: [],
    sports: [],
    paging: {
        total: 0,
        page: 1,
        pages: 1
    },
    loading: true,
    lastEmptyResponseTime: null // to track cooldown
};

const getters = {
    getFormattedEvents: (state) => state.events,
    getSports: (state) => state.sports,
    getPaging: (state) => state.paging,
    isLoading: (state) => state.loading
};

const mutations = {
    SET_LOADING(state, status) {
        state.loading = status;
    },

    SET_DATA(state, { events, paging, sports }) {
        state.events = events;
        if (paging) state.paging = paging;
        if (sports) state.sports = sports;

        state.lastEmptyResponseTime = null; // Reset the timer if data arrives
    },

    RESET_DATA(state) {
        state.events = [];
        state.paging = { total: 0, page: 1, pages: 1 };
        // Do not reset sports to avoid flickering
        state.lastEmptyResponseTime = Date.now(); //  Mark that the API returned an empty response
    }
};

const actions = {
    async fetchStartingSoon(context, payload) {
        if (context.rootGetters['ui/getAppSection'] === 'live') return;
        const p = payload || {};

        // --- SMART POLLING LOGIC ---
        // If it's not a forced refresh and we're in cooldown (e.g., 2 minutes since last empty response)
        if (!p.force && context.state.events.length === 0 && context.state.lastEmptyResponseTime) {
            const minutesSinceLastEmpty = (Date.now() - context.state.lastEmptyResponseTime) / 1000 / 60;
            if (minutesSinceLastEmpty < 2) {
                return;
            }
        }

        context.commit('SET_LOADING', true);

        const requestPayload = {
            platformId: context.rootGetters['settings/getPlatformId'],
            sportId: p.sportId || null,
            page: p.page || 1,
            limit: p.limit || context.rootGetters['settings/getStartingSoonMaxEventsForPage'] || 10,
            language_user: p.language_user,
            mobilePlatform: p.mobilePlatform || false
        };

        const apiUrl = context.rootGetters['settings/getUrlApi'];
        const token = context.rootGetters['settings/getToken'];
        //const url = `${apiUrl}/events/get-starting-soon-v4`;
        const url = `${apiUrl}/v3/events/prematch/last-minute`;
        const headers = { Authorization: `Bearer ${token}` };

        try {
            const response = await axios.post(url, requestPayload, { headers });
            const data = response.data;

            if (data && data.result && data.result.events && data.result.events.length > 0) {
                const formattedEvents = refactorEventsGroupedByDateV1(data.result);

                context.commit('SET_DATA', {
                    events: formattedEvents,
                    paging: data.result.paging,
                    sports: data.result.sports
                });

                if (data.result.headerSign) {
                    // context.dispatch(
                    //     'marketview/updateSpreadsListAndSpreadSelectedV3',
                    //     {
                    //         type: 'startingSoon',
                    //         headerSign: data.result.headerSign,
                    //         sport: requestPayload.sportId,
                    //         events: data.result.events
                    //     },
                    //     { root: true }
                    // );
                }
            } else {
                context.commit('RESET_DATA'); // This now sets lastEmptyResponseTime
            }
        } catch (error) {
            console.error("Error in fetchStartingSoon:", error);
            context.commit('RESET_DATA');
        } finally {
            context.commit('SET_LOADING', false);
        }
    }
};

export default {
    namespaced: true,
    state,
    getters,
    actions,
    mutations
};